<div class="app-main login-css-new" style="background-image: url('assets/img/login-bg.jpg');">
    <div class="app-content p-0">
        <div class="app-content--inner d-flex align-items-center">
            <div class="flex-grow-1 w-100 d-flex align-items-center">
                <div class="bg-composed-wrapper--content py-5">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-sm-12 mx-auto text-center align-items-center">

                                <div class="card card-box">
                                    <div class=" justify-content-between px-5 py-5">
                                        <div class="align-items-center pb-4">
                                            <img alt="..." class="w-50 mx-auto d-block img-fluid"
                                                src="assets/img/logo__airport-butler-dark.svg">
                                        </div>
                                        <div class="pl-0">
                                            <div class="text-black mt-3">
                                                <div>
                                                    <form [formGroup]="forget_form"
                                                        (ngSubmit)="onSubmit(forget_form.value)">
                                                        <div class="form-group text-left">
                                                            <label>Enter email address to reset your password.</label>
                                                            <input class="form-control" placeholder="Email"
                                                                formControlName="email" type="email" required
                                                                placeholder="yourname@yourmail.com"
                                                                [ngClass]="{'is-invalid': submitted && forget_form.get('email').errors}">
                                                            <div *ngFor="let validation of validation_messages.email">
                                                                <div class="error-message"
                                                                    *ngIf="f.email.hasError(validation.type) &&  ((f.email.dirty || f.email.touched))">
                                                                    {{validation.message }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button style="
                                                    width: 70%;
                                                    display: block;
                                                    margin: 0 auto;
                                                    " class="btn btn-lg btn-second btn-block"
                                                            type="submit">Submit</button>
                                                    </form>
                                                    <div class="text-center pt-3">
                                                        <a [routerLink]="['/login']">Login</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>